import Image from "next/image";
import Link from "next/link";
import React, { useContext } from "react";
import { ROUTES } from "../../../services/router-services";
import styles from "./recentSearch.module.scss";
import { WeeklyTopSearchProduct } from "../../../models/home-rows";
import AppContext from "../../../services/app-context-services";

type RecentSearch = {
  recentSearch: WeeklyTopSearchProduct[];
};

export const RecentSearch = ({ recentSearch }: RecentSearch) => {
  const {setCloseSearchModal} = useContext(AppContext);
  return (
    <>
      <h3 className={styles.title}>جستجوهای اخیر تو</h3>
      <div className={styles.resultCardWrapper}>
        {recentSearch?.map(product => (
          <Link
            href={ROUTES.product(product)}
            key={product?.id}
          >
            <div className={`${styles.card} `} onClick={() => setCloseSearchModal(true)}>
              <div className={styles.cardPoster}>
                {product?.avatar && (
                  <Image
                    src={product?.avatar.xhdpi}
                    alt={`Image for ${product?.name}`}
                    width={192}
                    height={277}
                  />
                )}
              </div>
              <div className={styles.cardTitle}>{product?.name}</div>
            </div>
          </Link>
        ))}
      </div>
    </>
  );
};
